import * as React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';

interface ErrorMessageProps {
  // tslint:disable-next-line:no-any
  children: any;
  onDismiss?: () => void;
  focusOnMount?: boolean;
  containerClassName?: string;
  className?: string;
  closeMessageAriaLabel?: string;
  isMultiLine?: boolean;
}

export class ErrorMessage extends React.Component<ErrorMessageProps> {
  private errorMessageRef: HTMLDivElement;

  componentDidMount() {
    if (this.errorMessageRef && this.props.focusOnMount) {
      this.errorMessageRef.focus();
    }
  }

  render() {
    return (
      <div
        tabIndex={-1}
        ref={(ref: HTMLDivElement) => (this.errorMessageRef = ref)}
        className={this.props.containerClassName}>
        <MessageBar
          className={`error-padding-top ${this.props.className}`}
          dismissButtonAriaLabel={''}
          messageBarType={MessageBarType.error}
          onDismiss={this.props.onDismiss}
          isMultiline={this.props.isMultiLine}>
          {this.props.children}
        </MessageBar>
      </div>
    );
  }
}
